import { render, staticRenderFns } from "./DonutChart37.vue?vue&type=template&id=055e8a63&scoped=true&"
import script from "./DonutChart37.vue?vue&type=script&lang=js&"
export * from "./DonutChart37.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055e8a63",
  null
  
)

export default component.exports